let registrationPromise

export const registerServiceWorker = () => {
  if (!navigator.serviceWorker) return Promise.resolve(null)

  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker.register("/service-worker.js")
      .catch(error => {
        registrationPromise = null
        throw error
      })
  }

  return registrationPromise
}
